import { s } from "@kosmod/pancake";

export const SESAME_AUTH_SUBPROTOCOL = 'kosmod.auth.v1';

export type SendCredentialMessage = {
  type: 'authorize',
  token: string,
}
export const SendCredentialMessage = s.ref<SendCredentialMessage>()(s.o({
  type: s.l('authorize'),
  token: s.str,
}));

export type ConfirmCredentialMessage = {
  type: 'authorize-confirm',
  result: "accept" | "reject"
};
export const ConfirmCredentialMessage = s.ref<ConfirmCredentialMessage>()(s.o({
  type: s.l('authorize-confirm'),
  result: s.lu(['accept', 'reject']),
}));
